import { render } from "./stock-transfer-report.vue?vue&type=template&id=d9fa16b6&scoped=true"
import script from "./stock-transfer-report.vue?vue&type=script&lang=js"
export * from "./stock-transfer-report.vue?vue&type=script&lang=js"

import "./stock-transfer-report.vue?vue&type=style&index=0&id=d9fa16b6&scoped=true&lang=css"

import exportComponent from "/home/runner/work/inventflux-frontend/inventflux-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d9fa16b6"]])

export default __exports__